module.exports = __webpack_public_path__ + "static/media/guro.db86a357.svg";